import { jsx as _jsx } from "react/jsx-runtime";
import { Price as BuyPriceView } from "./BuyView/Price";
import { Price as RentView } from "./RentView/Price";
import { Price as DefaultView } from "./DefaultView/Price";
import { AlternatePrice as AlternateBuyPriceView } from "./BuyView/AlternatePrice";
import { usePriceLayout } from "./hooks/usePriceLayout";
import { PriceLayoutEnum } from "@/types/price";
export const Price = () => {
    const layout = usePriceLayout();
    switch (layout) {
        case PriceLayoutEnum.GERMAN_SALE:
            return _jsx(BuyPriceView, {}); // German buy layout
        case PriceLayoutEnum.GERMAN_RENT:
            return _jsx(RentView, {}); // German rent layout
        case PriceLayoutEnum.FRENCH_SALE:
            return _jsx(AlternateBuyPriceView, {});
        default:
            return _jsx(DefaultView, {}); // default layout
    }
};
